import { render } from "./PaginacionTabla.vue?vue&type=template&id=07f7c4ac&scoped=true"
import script from "./PaginacionTabla.vue?vue&type=script&lang=js"
export * from "./PaginacionTabla.vue?vue&type=script&lang=js"

import "./PaginacionTabla.vue?vue&type=style&index=0&id=07f7c4ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f7c4ac"]])

export default __exports__